import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegratedFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17 10.8C19.0522 10.8 20.8716 11.7971 22 13.3332V8V5H12L10 2H2V4V18H10.8802C10.8274 17.6745 10.8 17.3404 10.8 17C10.8 13.5758 13.5758 10.8 17 10.8ZM17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17C12 19.7614 14.2386 22 17 22ZM19.8242 15.5743L16.8242 18.5743L16.4 18.9986L15.9757 18.5743L14.1757 16.7743L15.0242 15.9258L16.4 17.3015L18.9757 14.7258L19.8242 15.5743Z",
		fill: "currentColor"
	})
});
export default SvgIntegratedFilled;
